import styled from 'styled-components';

export const Container = styled.div`
  
`;

export const Header = styled.div`
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #D3D3D3;
  h2 {
    font-family: 'Poppins';
    font-size: 22px;
    font-weight: 400;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 400px;

  .input-wrapper {
    display: inline-flex;
    flex-direction: column;
    gap: 4px;

    span {
        color: #f7345b;
        font-family: 'Inter';
        font-size: 14px;
    }

    .input {
        background: #fff;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;


